import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SummernoteOptions } from 'ngx-summernote/lib/summernote-options';

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.scss']
})
export class RichTextEditorComponent {

  @Input() textToEdit: string = "";
  @Input() inputHeight: number|undefined = undefined;
  @Output() textToEditChange = new EventEmitter();

  @Input() config: SummernoteOptions = {
    placeholder: '',
    tabsize: 2,
    height: 200,
    uploadImagePath: '/api/upload',
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['strikethrough', 'superscript', 'subscript']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']],
      ['insert', ['table', 'picture', 'link', 'hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times'],
    
  }

  ngOnInit(){
    if(this.inputHeight !== undefined){
      this.config.height = this.inputHeight;
    }
  }

  updateOriginalModel() {
    this.textToEditChange.emit(this.textToEdit);
  }

}
